import { useState } from "react";
import useTranslation from "../../hooks/i18n/useTranslation";
import IconsEnum from "../../classes/enums/IconsEnum";
import IconButton from "../iconButton/IconButton";
import "./WidgetBox.css";

function WidgetBox({
  // Content props
  children,
  title = null,
  imageUrl = null,

  // Behavior props
  isExpandable = false,
  isExpanded = null,
  isClosable = false,
  isMaximizable = false,
  onClose = () => {},
  onMaximize = () => {},
  onToggleExpand = null,

  // Style props
  isSmall = false,
  isInSideBar = false,
  noBgColor = false,
  noHeader = false,
  noHorizontalPadding = false,
  noVerticalPadding = false,
  toggleTitleColor = false,

  // Layout props
  minHeight = null,
  name = "",
}) {
  const { t } = useTranslation();
  const [internalExpanded, setInternalExpanded] = useState(true);

  const expanded = isExpanded !== null ? isExpanded : internalExpanded;

  const handleExpandClick = e => {
    e.stopPropagation();
    if (onToggleExpand) {
      onToggleExpand();
    } else {
      setInternalExpanded(!internalExpanded);
    }
  };

  const handleCloseClick = e => {
    e.stopPropagation();
    onClose();
  };

  return (
    <div
      className={`App-widget-box ${expanded ? "expanded" : "collapsed"} ${
        noBgColor ? "App-widget-box-no-bgColor" : ""
      } ${isInSideBar ? "App-widget-box-side-bar" : ""}  ${
        noVerticalPadding ? "App-widget-box-no-vertical-padding" : ""
      } ${name}`}
      style={{ minHeight: expanded && minHeight ? minHeight : "auto" }}
    >
      {!noHeader && title && (
        <div
          className={`App-widget-box-title ${
            isExpandable ? "expandable" : ""
          } ${isSmall ? "App-widget-box-title-small" : ""} ${
            toggleTitleColor ? "App-widget-box-title-toggle-color" : ""
          } ${
            imageUrl
              ? "App-widget-box-title-with-image"
              : "App-widget-box-title-without-image"
          }`}
        >
          {imageUrl && (
            <div className="App-widget-box-image-container">
              <img
                src={imageUrl}
                alt="Widget icon"
                className="App-widget-box-image"
              />
            </div>
          )}
          <span
            className={`App-title-widgets ${
              isSmall ? "App-widget-title-text App-text-large" : ""
            }`}
          >
            {title}
          </span>
          <div className="App-widget-box-icons">
            {isExpandable && (
              <IconButton
                icon={expanded ? IconsEnum.ARROWUP : IconsEnum.ARROWDOWN}
                noBgColor={true}
                onClick={handleExpandClick}
                className={`App-widget-box-icon ${
                  isSmall ? "App-widget-box-icon-small" : ""
                }`}
                title={expanded ? t("434") : t("433")}
              />
            )}
            {isMaximizable && (
              <IconButton
                icon={IconsEnum.RESIZE}
                noBgColor={true}
                onClick={onMaximize}
                className={`App-widget-box-icon ${
                  isSmall ? "App-widget-box-icon-small" : ""
                }`}
                title={t("435")}
              />
            )}
            {isClosable && (
              <IconButton
                icon={IconsEnum.CLOSE}
                noBgColor={true}
                onClick={handleCloseClick}
                className={`App-widget-box-icon ${
                  isSmall ? "App-widget-box-icon-small" : ""
                }`}
                title={t("43")}
              />
            )}
          </div>
        </div>
      )}
      {expanded && (
        <div
          className={`App-widget-box-contain ${
            noHorizontalPadding
              ? "App-widget-box-contain-no-horizontal-padding"
              : ""
          }`}
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default WidgetBox;
